<!--
 * @Author: zhaozhuo
 * @Date: 2021-12-13 16:30:53
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-04-01 17:20:36
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\utilsComponents\timePicker\index.vue
-->
<template>
  <div>
    <DhcFieldInput v-model="formOption" :inputData="formOption.value" placeholder="点击选择时间" :disable="disable" @changeFieldData="changeFieldData"></DhcFieldInput>
    <van-popup v-model="formOption.isPopFlag" position="bottom">
      <van-picker show-toolbar title="选择时间" :columns="timeColumns"
                  @confirm="onTimePickerConfirm" @cancel="formOption.isPopFlag = false"
      >
        <template #option="item">
          {{ item }}
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>
<script>
import { getTimeDatas } from '@/utils/date.js'
export default {
	props: {
		value: {
			type: Object,
			default: {}
		},
		disable: { // 禁止
			type: [Boolean, Number],
			default: false
		}
	},
	data() {
		return {
			timeColumns: []
		}
	},
	computed: {
		formOption: {
			get: function() {
				return this.value
			},
			set: function() {
				return
			}
		}
	},
	watch: {
		'formOption': {
			handler(newValue) {
				this.timeColumns = getTimeDatas(newValue.value)
				this.$emit('changePickerData', newValue)
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		// 时间选择器确认
		onTimePickerConfirm(value) {
			this.formOption.value = value.join(':')
			this.formOption.isPopFlag = false
		},
		// 改变input框数据
		changeFieldData(data) {
			this.formOption = data
		}
	}
}
</script>
<style lang="scss" scoped>
</style>